import { render, staticRenderFns } from "./SourceClass.vue?vue&type=template&id=a61a6a20&scoped=true"
import script from "./SourceClass.vue?vue&type=script&lang=js"
export * from "./SourceClass.vue?vue&type=script&lang=js"
import style0 from "./SourceClass.vue?vue&type=style&index=0&id=a61a6a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61a6a20",
  null
  
)

export default component.exports